import { render } from "./damage-td.vue?vue&type=template&id=6295e57c"
import script from "./damage-td.vue?vue&type=script&lang=js"
export * from "./damage-td.vue?vue&type=script&lang=js"

import "./damage-td.vue?vue&type=style&index=0&id=6295e57c&lang=css"
script.render = render

export default script